// Values mirror the backend `PlatformService.name`.
enum PlatformServiceNameEnum {
  SERVICE_FEE = "servicefee",
  FACTORING = "factoring",
}

export default PlatformServiceNameEnum;
